














import Vue from 'vue';
import Component from 'vue-class-component';
import Header from '@/components/header/Header.vue';
import Footer from '@/components/footer/Footer.vue';

@Component({
  components: {
    Header,
    Footer,
  },
})

export default class App extends Vue {
  public mounted() {
    this.$i18n.locale = this.locale;
  }

  get locale(): string {
    return this.$store.getters.locale;
  }

  get showNavigation(): any {
      return this.$store.getters.getShowFooter;
  }
  get loader(): boolean {
      return this.$store.getters.getLoader;
  }
}
